import moment from "moment";

// Function to convert ISO date string to a formatted date string
export const isoToDate = (isoString) => {
  if (isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
};

// Function to convert date to ISO format
export const datesToISO = (date) => {
  if (date) {
    date = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
    return date;
  }
  return null;
};

// Function to convert time to full date
export const timeToDate = (timeString) => {
  if (!timeString) return null;
  const [hours, minutes, seconds] = timeString.split(":");
  const date = new Date(); // Use today's date
  date.setHours(Number(hours), Number(minutes), Number(seconds), 0); // Set the time
  return date;
};

// Function date to time
export const dateToTime = (date) => {

  if (!date || isNaN(date.getTime())) {
    return '';
  }
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}:00`;
};
// Function to format a date string
export const formatDate = (date) => {
  if (date) {

    return moment(date).format("YYYY-MM-DD");
  }
};

// Format date and time to YYYY-MM-DD HH:mm
export const formatTimeDate = (date) => {
  if (!date) return null;
  return moment(date).format("YYYY-MM-DD HH:mm");
};

// Format date and time to HH:mm
export const formatTime = (date) => {
  if (!date) return null;
  return moment(date).format("HH:mm");
};

// format time to
